import React from 'react';
import * as ActionTypes from '../../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const manageSectionStoreDefaults = {
    themelevel: {
        selected: 'chain',
        hotels: [
            { key: 'WH', label: 'Wyndham' },
            { key: 'AZ', label: 'Ascott' },
            { key: 'WW', label: 'Warwick' }
        ],
        availableThemes: [
            { key: 'TH1', label: 'Mock Theme 1' },
            { key: 'TH2', label: 'Mock Theme 2' }
        ]
    },
    configlevel: {
        selected: 'chain',
        hotels: [
            { key: 'WH', label: 'Wyndham' },
            { key: 'AZ', label: 'Ascott' },
            { key: 'WW', label: 'Warwick' }
        ],
        availableThemes: [
            { key: 'TH1', label: 'Mock Theme 1' },
            { key: 'TH2', label: 'Mock Theme 2' }
        ]
    },
    history: {
        themes: {
            KIM1: [
                {
                    updated: '2015/09/18T15:30:00.000Z',
                    comment: 'This is a comment!'
                },
                { updated: '2015/19/17R15:30:00.000Z', comment: 'Mock comment 1' }
            ],
            SUMM: [
                {
                    updated: '2014/09/18T15:30:00.000Z',
                    comment: 'This is a comment!'
                },
                { updated: '2014/19/17R15:30:00.000Z', comment: 'Mock comment 2' }
            ]
        },
        configs: {
            STD1: [
                {
                    updated: '2015/09/18T15:30:00.000Z',
                    comment: 'This is a comment!'
                },
                { updated: '2015/19/17R15:30:00.000Z', comment: 'Mock comment 3' }
            ],
            MIN1: [
                {
                    updated: '2014/09/18T15:30:00.000Z',
                    comment: 'This is a comment!'
                },
                { updated: '2014/19/17R15:30:00.000Z', comment: 'Mock comment 4' }
            ]
        }
    },
    hotelList: []
};

const manageReducer = handleActions(
    {
        [ActionTypes.LOGIN_SET_HOTELLIST]: (state, action) => {
            return { ...state, hotelList: action.hotelList };
        },
        [ActionTypes.LOGIN_SET_CHAINLIST]: (state, action) => {
            return { ...state, chainList: action.chainList, accessibleChains: action.accessibleChains };
        },
        [ActionTypes.SET_HOTELLIST]: (state, action) => {
            return { ...state, hotelList: action.payload.hotelList };
        },
        [ActionTypes.ADD_SALESFORCE_ALLOWED_DOMAIN]: (state, action) => {
            const allowedSalesforceDomains = { ...state['allowedSalesforceDomains'], [action.code]: action.value };
            return { ...state, allowedSalesforceDomains };
        }
    },
    manageSectionStoreDefaults
);

export default manageReducer;



// WEBPACK FOOTER //
// ./src/reducers/manage/manage.js